import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import {
    fetchNationReportSubGroups,
    fetchTemplateReportSubGroups,
    createReportSubGroup,
    updateReportSubGroup,
    enableReportSubGroup,
    disableReportSubGroup,
    assignTemplateReportSubGroups,
    removeTemplateReportSubGroups,
} from "@features/report/subgroup/api/reportSubGroupApi";
import {
    ReportSubGroupAssignmentResponse,
    ReportSubGroupResponse,
} from "@features/report/subgroup/types/reportSubGroup";
import {
    AssignTemplateReportSubGroupsRequest,
    CreateReportSubGroupRequest,
    RemoveTemplateReportSubGroupsRequest,
    UpdateReportSubGroupRequest,
} from "@features/report/subgroup/types/reportSubGroupRequests";

export const fetchNationReportSubGroupsAsync = async (
    nationId: number,
    params: any
): Promise<ApiResponse<ReportSubGroupResponse>> => {
    return fetchNationReportSubGroups(nationId, params);
};

export const fetchTemplateReportSubGroupsAsync = async (
    nationId: number,
    departmentId: number,
    reportTemplateId: number,
    params: any
): Promise<ApiResponse<ReportSubGroupAssignmentResponse>> => {
    return fetchTemplateReportSubGroups(nationId, departmentId, reportTemplateId, params);
};

export const createReportSubGroupAsync = async (
    nationId: number,
    data: CreateReportSubGroupRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return createReportSubGroup(nationId, data);
};

export const updateReportSubGroupAsync = async (
    nationId: number,
    reportSubGroupId: number,
    data: UpdateReportSubGroupRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return updateReportSubGroup(nationId, reportSubGroupId, data);
};

export const disableReportSubGroupAsync = async (
    nationId: number,
    reportSubGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return disableReportSubGroup(nationId, reportSubGroupId);
};

export const enableReportSubGroupAsync = async (
    nationId: number,
    reportSubGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return enableReportSubGroup(nationId, reportSubGroupId);
};

export const assignTemplateReportSubGroupsAsync = async (
    nationId: number,
    departmentId: number,
    reportTemplateId: number,
    data: AssignTemplateReportSubGroupsRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return assignTemplateReportSubGroups(nationId, departmentId, reportTemplateId, data);
};

export const removeTemplateReportSubGroupsAsync = async (
    nationId: number,
    departmentId: number,
    reportTemplateId: number,
    data: RemoveTemplateReportSubGroupsRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return removeTemplateReportSubGroups(nationId, departmentId, reportTemplateId, data);
};
